import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {TabItemComponent} from './tab-item/tab-item.component';
import {TabsWrapperComponent} from './tabs-wrapper/tabs-wrapper.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        TabItemComponent,
        TabsWrapperComponent
    ],
    declarations: [
        TabItemComponent,
        TabsWrapperComponent
    ]
})
export class TabsModule {
}



// WEBPACK FOOTER //
// /app/src/app/components/tabs/tabs.module.ts